module.exports = __webpack_public_path__ + "static/media/kayak_first_person.847089c2.png";